// This pure codec is also shipped to the browser. Arrays are stored as individual
// records; their container never contains the full list or a growing list of IDs.
const escapeKey = key => String(key).replace(/~/g, '~0').replace(/\//g, '~1');
const unsafe = key => ['__proto__', 'constructor', 'prototype'].includes(key);
function encode(value) {
  const records = {};
  function visit(node, path) {
    if (Array.isArray(node)) {
      records[path] = { type: 'array' };
      const seen = new Set();
      node.forEach((item, position) => {
        const id = item && typeof item === 'object' && item.id != null ? String(item.id) : `index:${position}`;
        if (seen.has(id)) throw new Error('Identificador de registro duplicado');
        seen.add(id);
        records[`${path}/@${escapeKey(id)}`] = { type: 'item', position, value: item };
      });
    } else if (node && typeof node === 'object') {
      records[path] = { type: 'object' };
      Object.keys(node).sort().forEach(key => {
        if (unsafe(key)) throw new Error('Campo no permitido');
        visit(node[key], `${path}/${escapeKey(key)}`);
      });
    } else {
      records[path] = { type: 'value', value: node };
    }
  }
  visit(value, '$');
  return records;
}
function decode(records) {
  function read(path) {
    const node = records[path];
    if (!node) throw new Error('Estructura de registros incompleta');
    const children = Object.keys(records).filter(key => key.startsWith(path + '/') && !key.slice(path.length + 1).includes('/'));
    if (node.type === 'array') return children.sort((a, b) => records[a].position - records[b].position || a.localeCompare(b)).map(key => records[key].value);
    if (node.type === 'object') return Object.fromEntries(children.map(key => [key.slice(path.length + 1).replace(/~1/g, '/').replace(/~0/g, '~'), read(key)]));
    return node.value;
  }
  return read('$');
}
const canonical = value => Array.isArray(value) ? value.map(canonical) : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map(key => [key, canonical(value[key])])) : value;
const equal = (a, b) => JSON.stringify(canonical(a)) === JSON.stringify(canonical(b));
module.exports = { encode, decode, canonical, equal };
